import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import PptxGenJS from "pptxgenjs";
import toastEmitter from "./toastEmitter";

export async function exportPNG(elementId, fileName = "chart.png") {
  const element = document.getElementById(elementId);
  if (!element) {
    toastEmitter.emit("Element not found for export.", "error");
    return;
  }
  const canvas = await html2canvas(element, { scale: 2 });
  canvas.toBlob((blob) => saveAs(blob, fileName));
}

export async function exportPDF(elementId, fileName = "chart.pdf") {
  const element = document.getElementById(elementId);
  if (!element) {
    toastEmitter.emit("Element not found for export.", "error");
    return;
  }
  const canvas = await html2canvas(element, { scale: 2 });
  const imgData = canvas.toDataURL("image/png");
  const pdf = new jsPDF("p", "mm", "a4");
  const pdfWidth = pdf.internal.pageSize.width;
  const imgProps = pdf.getImageProperties(imgData);
  const height = (imgProps.height * pdfWidth) / imgProps.width;
  pdf.addImage(imgData, "PNG", 0, 5, pdfWidth, height);
  pdf.save(fileName);
}

export function exportXLSX(data, fileName = "table.xlsx") {
  if (!Array.isArray(data)) {
    toastEmitter.emit("Invalid data for export.", "error");
    return;
  }
  const ws = XLSX.utils.json_to_sheet(data);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
  XLSX.writeFile(wb, fileName);
}

export function exportCSV(data, fileName = "table.csv") {
  if (!Array.isArray(data)) {
    toastEmitter.emit("Invalid data for export.", "error");
    return;
  }
  const ws = XLSX.utils.json_to_sheet(data);
  const csv = XLSX.utils.sheet_to_csv(ws);
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  saveAs(blob, fileName);
}

export async function exportPPT(elementId, title = "Slide", fileName = "chart.pptx") {
  const element = document.getElementById(elementId);
  if (!element) {
    toastEmitter.emit("Element not found for export.", "error");
    return;
  }
  const canvas = await html2canvas(element, { scale: 2 });
  const img = canvas.toDataURL("image/png");
  const pptx = new PptxGenJS();
  const slide = pptx.addSlide();
  slide.addText(title, { x: 0.5, y: 0.3, fontSize: 20, bold: true });
  slide.addImage({ data: img, x: 0.5, y: 1, w: 9 });
  pptx.writeFile({ fileName });
}

export function flattenCrosstab(crosstab) {
  if (!crosstab || !crosstab.rows || !crosstab.columns || !crosstab.matrix) {
    toastEmitter.emit("Invalid crosstab data for export.", "error");
    return [];
  }
  const { rows, columns, matrix } = crosstab;
  const flat = [];
  rows.forEach((row, rIndex) => {
    if (row === "__MISSING__") return;
    const rowData = matrix[rIndex];
    const obj = { Row: row };
    columns.forEach((col) => {
      if (col !== "__MISSING__") {
        obj[`${col} %`] = rowData[col]?.percent ?? 0;
        obj[`${col} Value`] = rowData[col]?.value ?? 0;
      }
    });
    flat.push(obj);
  });
  return flat;
}
